import React from "react";

const AboutSection = () => {
  return (
    <>
      <section className="about-section rel z-1 pt-100 rpt-70 pb-50" id="about">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-left rmb-55 wow fadeInLeft delay-0-2s">
                <img src="https://attherate.dev/host-image/uploads/1760377679_Screenshot_21.png" alt="About" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-content wow fadeInRight delay-0-2s">
                <div className="section-title mb-30">
                  <span className="sub-title">Our Technology</span>
                  <h2>
                    Revolutionary AI-Powered <span>Design-to-Code</span> Platform
                  </h2>
                </div>
                <p>
                  Our cutting-edge AI technology transforms your UI/UX designs into production-ready HTML & CSS code in seconds. Eliminate hours of manual coding while maintaining pixel-perfect accuracy across all devices and frameworks.
                </p>
                <ul className="list-style-one pt-5 pb-30">
                  <li>Instant Design-to-Code Conversion</li>
                  <li>Pixel-Perfect Responsive Output</li>
                  <li>Framework-Agnostic Implementation</li>
                </ul>
                <a href="#" className="theme-btn">
                  See Pricing <i className="fas fa-long-arrow-alt-right" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="about-bg-shape">
          <img src="/assets/images/about/about-bg-shape.png" alt="About Shape" />
        </div>
      </section>
    </>
  );
};

export default AboutSection;